import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { PubMainTypeEnum, PubSuffixTypeEnum } from '../../../types';
/** this function return intial tab index based on the intial form state */
var getInitialTabIndex = function getInitialTabIndex(pubtype) {
  if (pubtype) {
    switch (pubtype.main) {
      case PubMainTypeEnum.PUB_ONLINE:
        return 2;
      case PubMainTypeEnum.PUB_NONPERIODICAL:
        if (pubtype.suffix === PubSuffixTypeEnum.PUB_ONLINE) return 2;
        if (pubtype.suffix === PubSuffixTypeEnum.PUB_DATABASE) return 3;else return 1;
      default:
        return 0;
    }
  }
  return 0;
};
var getPubTypeSuffixEnumFromTabIndex = function getPubTypeSuffixEnumFromTabIndex(index) {
  if (index === 3) return PubMainTypeEnum.PUB_DATABASE;else return PubMainTypeEnum.PUB_NONE;
};
var getPubTypeMainEnumFromTabIndex = function getPubTypeMainEnumFromTabIndex(index) {
  switch (index) {
    case 1:
      return PubMainTypeEnum.PUB_NONPERIODICAL;
    case 2:
      return PubMainTypeEnum.PUB_ONLINE;
    case 3:
      return PubMainTypeEnum.PUB_NONPERIODICAL;
    case 0:
    default:
      return PubMainTypeEnum.PUB_NONE;
  }
};
var usePaintingTabs = function usePaintingTabs(_ref) {
  var intialPubtypeState = _ref.intialPubtypeState;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var initialActiveIndex = getInitialTabIndex(intialPubtypeState);
  var _useState = useState(initialActiveIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabIndex = _useState2[0],
    setActiveTabIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    preservedPubtypeStateForTabs = _useState4[0],
    setPreservedPubtypeStateForTabs = _useState4[1];

  /** This will initialize the pubtype state, if not already present */
  useEffect(function () {
    if (!intialPubtypeState) {
      setFieldValue('pubtype', {
        main: getPubTypeMainEnumFromTabIndex(initialActiveIndex),
        suffix: getPubTypeSuffixEnumFromTabIndex(initialActiveIndex)
      });
    }
    setPreservedPubtypeStateForTabs([]);
    setActiveTabIndex(getInitialTabIndex(intialPubtypeState));
  }, [intialPubtypeState]);
  var handleTabChange = function handleTabChange(newActiveTabIndex) {
    /** copying prev state, before any change happens */
    var prevActiveIndex = activeTabIndex;
    var prevMainPubTypeValue = values.pubtype.main;
    var prevSuffixPubTypeValue = values.pubtype.suffix;
    setActiveTabIndex(newActiveTabIndex);
    /** updating formik state with preserved/default value for that tab-index */
    if (preservedPubtypeStateForTabs[newActiveTabIndex]) {
      setFieldValue('pubtype', preservedPubtypeStateForTabs[newActiveTabIndex]);
    } else {
      setFieldValue('pubtype', {
        main: getPubTypeMainEnumFromTabIndex(newActiveTabIndex),
        suffix: getPubTypeSuffixEnumFromTabIndex(newActiveTabIndex)
      });
    }
    var initialePaintingObj = values.painting;
    if (newActiveTabIndex !== 0) {
      setFieldValue('painting', _objectSpread(_objectSpread({}, initialePaintingObj), {}, {
        medium: '',
        publisher: '',
        publisherlocation: ''
      }));
    }
    /** preserving prev state */
    setPreservedPubtypeStateForTabs(function (state) {
      state[prevActiveIndex] = {
        main: prevMainPubTypeValue,
        suffix: prevSuffixPubTypeValue
      };
      return state;
    });
  };
  return {
    activeTabIndex: activeTabIndex,
    handleTabChange: handleTabChange
  };
};
export default usePaintingTabs;